// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* modificador de estilo general de calendar */
.sx-react-calendar-wrapper{
    margin:auto;
    /* margin-top: 4vh; */
    height: 78vh;
    width: 80vw;
    border-radius: 10px;
    background-color: white;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1), 
                0 6px 20px rgba(0, 0, 0, 0.1);
  }
  .sx__calendar-wrapper {
    color: var(--third-color) !important;
    font-size: var(--font-size-small) !important;
  }
  .sx__today-button{
color:var(--txt-color)!important;
font-size: var(--font-size-small)!important;
  }
  .sx__view-selection-selected-item{
    color:var(--txt-color)!important;
    font-size: var(--font-size-small)!important;
  }
  .sx__calendar-header .sx__date-input{
    color:var(--txt-color) !important;
    font-size: var(--font-size-small) !important;
  }
  .sx__range-heading{
    font-size: var(--font-size-med) !important;
  }
  .sx__chevron-wrapper .sx__chevron{
    width: 0.5rem !important;
    height: 0.5rem !important;
    border-color: var(--main-color) !important;
  }
  .sx__week-grid__date--is-today .sx__week-grid__date-number{
    background-color: var(--second-color) !important;
  }
  .sx__week-grid__date--is-today .sx__week-grid__day-name{
    color: var(--second-color)!important;
  }
  .sx__week-grid__date-number{
    /* height: 1.5em;
    width: 1.5em; */
  font-size: var(--font-size-small) !important;
  }
  .sx__week-grid__day-name{
    font-size: var(--font-size-small) !important;
  }
  .sx__chevron-wrapper:hover{
    background-color: var(--border-table-color) !important;
  }
  .sx__view-selection-item:hover{
    background-color: var(--second-color) !important;
  }
  .sx__view-selection-item.is-selected:focus{
    background-color: var(--second-color) !important;
  }
  .sx__chevron-wrapper:focus{
    background-color: var(--border-table-color) !important;
  }
  .sx__event {
    background-color: var(--tag-calendar-color) !important;
    border-left:4px solid var(--second-color) !important;
  }
  .sx__date-grid-event-text{
    color: var(--third-color) !important;
  }
  .sx__date-picker__day.sx__date-picker__day--today{
    background-color: var(--second-color) !important;
    color: var(--white-color) !important;
  }
  .sx__date-picker__day:hover{
    background-color: var(--tag-calendar-color) !important;
  }
  .sx__date-picker__month-view-header__month-year:hover
  {
    color: var(--second-color) !important;
  }
  .sx__date-picker__month-view-header__month-year{
    color: var(--third-color) !important;
  }
  .sx__date-input--active .sx__date-input{
    border-color: var(--tag-calendar-color) !important;
  outline: 1px solid var(--tag-calendar-color) !important;
  }
  .sx__date-picker__day{
    color: var(--txt-color) !important;
  }
  .sx__date-input--active .sx__date-input-label{
    color: var(--tag-calendar-color) !important;
  }
  .date-calendar .reporte-gs-datepicker .rs-input{
 background-color: var(--white-color) !important;
 color: var(--txt-color) !important;
 /* border:1px solid var(--border-table-color) */
  }
  .sx__date-grid-event--left-overflow{
    background-color: var(--second-color) !important;
  }
  .sx__date-grid-event--right-overflow{
    background-color: var(--second-color) !important;
  }
  .date-calendar  .reporte-gs-datepicker .rs-input-group-addon{
    background-color: var(--white-color) !important;
    color: var(--txt-color) !important;
  }
  .date-calendar{
    width: 100%;
    /* height: 50%; */
  }
  .date-calendar .rs-picker-toggle-wrapper{
    width: 100%;
    /* height: 100%; */
  }`, "",{"version":3,"sources":["webpack://./src/components/provicionamiento-componentes/Maintenance/Maintenance-styles/Maintenance.css"],"names":[],"mappings":"AAAA,8CAA8C;AAC9C;IACI,WAAW;IACX,qBAAqB;IACrB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB;6CACyC;EAC3C;EACA;IACE,oCAAoC;IACpC,4CAA4C;EAC9C;EACA;AACF,gCAAgC;AAChC,2CAA2C;EACzC;EACA;IACE,gCAAgC;IAChC,2CAA2C;EAC7C;EACA;IACE,iCAAiC;IACjC,4CAA4C;EAC9C;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,wBAAwB;IACxB,yBAAyB;IACzB,0CAA0C;EAC5C;EACA;IACE,gDAAgD;EAClD;EACA;IACE,oCAAoC;EACtC;EACA;IACE;mBACe;EACjB,4CAA4C;EAC5C;EACA;IACE,4CAA4C;EAC9C;EACA;IACE,sDAAsD;EACxD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,sDAAsD;EACxD;EACA;IACE,sDAAsD;IACtD,oDAAoD;EACtD;EACA;IACE,oCAAoC;EACtC;EACA;IACE,gDAAgD;IAChD,oCAAoC;EACtC;EACA;IACE,sDAAsD;EACxD;EACA;;IAEE,qCAAqC;EACvC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,kDAAkD;EACpD,uDAAuD;EACvD;EACA;IACE,kCAAkC;EACpC;EACA;IACE,2CAA2C;EAC7C;EACA;CACD,+CAA+C;CAC/C,kCAAkC;CAClC,+CAA+C;EAC9C;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,+CAA+C;IAC/C,kCAAkC;EACpC;EACA;IACE,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,kBAAkB;EACpB","sourcesContent":["/* modificador de estilo general de calendar */\n.sx-react-calendar-wrapper{\n    margin:auto;\n    /* margin-top: 4vh; */\n    height: 78vh;\n    width: 80vw;\n    border-radius: 10px;\n    background-color: white;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1), \n                0 6px 20px rgba(0, 0, 0, 0.1);\n  }\n  .sx__calendar-wrapper {\n    color: var(--third-color) !important;\n    font-size: var(--font-size-small) !important;\n  }\n  .sx__today-button{\ncolor:var(--txt-color)!important;\nfont-size: var(--font-size-small)!important;\n  }\n  .sx__view-selection-selected-item{\n    color:var(--txt-color)!important;\n    font-size: var(--font-size-small)!important;\n  }\n  .sx__calendar-header .sx__date-input{\n    color:var(--txt-color) !important;\n    font-size: var(--font-size-small) !important;\n  }\n  .sx__range-heading{\n    font-size: var(--font-size-med) !important;\n  }\n  .sx__chevron-wrapper .sx__chevron{\n    width: 0.5rem !important;\n    height: 0.5rem !important;\n    border-color: var(--main-color) !important;\n  }\n  .sx__week-grid__date--is-today .sx__week-grid__date-number{\n    background-color: var(--second-color) !important;\n  }\n  .sx__week-grid__date--is-today .sx__week-grid__day-name{\n    color: var(--second-color)!important;\n  }\n  .sx__week-grid__date-number{\n    /* height: 1.5em;\n    width: 1.5em; */\n  font-size: var(--font-size-small) !important;\n  }\n  .sx__week-grid__day-name{\n    font-size: var(--font-size-small) !important;\n  }\n  .sx__chevron-wrapper:hover{\n    background-color: var(--border-table-color) !important;\n  }\n  .sx__view-selection-item:hover{\n    background-color: var(--second-color) !important;\n  }\n  .sx__view-selection-item.is-selected:focus{\n    background-color: var(--second-color) !important;\n  }\n  .sx__chevron-wrapper:focus{\n    background-color: var(--border-table-color) !important;\n  }\n  .sx__event {\n    background-color: var(--tag-calendar-color) !important;\n    border-left:4px solid var(--second-color) !important;\n  }\n  .sx__date-grid-event-text{\n    color: var(--third-color) !important;\n  }\n  .sx__date-picker__day.sx__date-picker__day--today{\n    background-color: var(--second-color) !important;\n    color: var(--white-color) !important;\n  }\n  .sx__date-picker__day:hover{\n    background-color: var(--tag-calendar-color) !important;\n  }\n  .sx__date-picker__month-view-header__month-year:hover\n  {\n    color: var(--second-color) !important;\n  }\n  .sx__date-picker__month-view-header__month-year{\n    color: var(--third-color) !important;\n  }\n  .sx__date-input--active .sx__date-input{\n    border-color: var(--tag-calendar-color) !important;\n  outline: 1px solid var(--tag-calendar-color) !important;\n  }\n  .sx__date-picker__day{\n    color: var(--txt-color) !important;\n  }\n  .sx__date-input--active .sx__date-input-label{\n    color: var(--tag-calendar-color) !important;\n  }\n  .date-calendar .reporte-gs-datepicker .rs-input{\n background-color: var(--white-color) !important;\n color: var(--txt-color) !important;\n /* border:1px solid var(--border-table-color) */\n  }\n  .sx__date-grid-event--left-overflow{\n    background-color: var(--second-color) !important;\n  }\n  .sx__date-grid-event--right-overflow{\n    background-color: var(--second-color) !important;\n  }\n  .date-calendar  .reporte-gs-datepicker .rs-input-group-addon{\n    background-color: var(--white-color) !important;\n    color: var(--txt-color) !important;\n  }\n  .date-calendar{\n    width: 100%;\n    /* height: 50%; */\n  }\n  .date-calendar .rs-picker-toggle-wrapper{\n    width: 100%;\n    /* height: 100%; */\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
